import { render } from "./CardTag.vue?vue&type=template&id=2cc19ffb&scoped=true"
import script from "./CardTag.vue?vue&type=script&lang=js"
export * from "./CardTag.vue?vue&type=script&lang=js"

import "./CardTag.vue?vue&type=style&index=0&id=2cc19ffb&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\Ned-ie\\ned_website-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc19ffb"]])

export default __exports__